import { useNumbro } from '@aspid/utils/hooks';

export const useCurrencyFormatter = (format: string = '0,0.00') => {
  const numeral = useNumbro();
  return (value: number | null | undefined) => {
    const formatted = numeral(value);
    return formatted.format(format);
  };
};
